import { Injectable, signal, computed } from "@angular/core";
import { LocationNode } from "../Dto/LocationData";
import { LocationOption } from "../Type/LocationSelectorTypes";

interface LocationSelectorComponentStateModel {
  locations: Record<string, LocationNode>;
  provinces: LocationOption[];
  districts: LocationOption[];
  subdistricts: LocationOption[];
  villages: LocationOption[];
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
}

const initialState: LocationSelectorComponentStateModel = {
  locations: {},
  provinces: [],
  districts: [],
  subdistricts: [],
  villages: [],
  isLoading: false,
  isLoaded: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class LocationSelectorComponentState {
  private readonly state = signal<LocationSelectorComponentStateModel>(initialState);

  public readonly locations = computed(() => this.state().locations);
  public readonly provinces = computed(() => this.state().provinces);
  public readonly districts = computed(() => this.state().districts);
  public readonly subdistricts = computed(() => this.state().subdistricts);
  public readonly villages = computed(() => this.state().villages);
  public readonly isLoading = computed(() => this.state().isLoading);
  public readonly isLoaded = computed(() => this.state().isLoaded);
  public readonly error = computed(() => this.state().error);

  setLoading(isLoading: boolean): void {
    this.state.update((state) => ({ ...state, isLoading }));
  }

  setLoaded(isLoaded: boolean): void {
    this.state.update((state) => ({ ...state, isLoaded }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error }));
  }

  setLocations(locations: Record<string, LocationNode>): void {
    this.state.update((state) => ({ ...state, locations }));
  }

  setProvinces(provinces: LocationOption[]): void {
    this.state.update((state) => ({ ...state, provinces }));
  }

  setDistricts(districts: LocationOption[]): void {
    this.state.update((state) => ({ ...state, districts }));
  }

  setSubdistricts(subdistricts: LocationOption[]): void {
    this.state.update((state) => ({ ...state, subdistricts }));
  }

  setVillages(villages: LocationOption[]): void {
    this.state.update((state) => ({ ...state, villages }));
  }

  reset(): void {
    this.state.set(initialState);
  }

  resetSelections(): void {
    this.state.update((state) => ({
      ...state,
      districts: [],
      subdistricts: [],
      villages: [],
    }));
  }
}
